<div
  class="alert-panel"
  [class.disabdivled]="viewModel.disabled"
  [class.clickable]="!viewModel.disabled"
  [ngClass]="viewModel.alertType.toLowerCase()"
  (click)="onClick()"
  tabindex="0"
  role="button"
  [attr.aria-disabled]="viewModel.disabled"
  (keydown.enter)="onClick()"
  (keydown.space)="$event.preventDefault(); onClick()"
>
  <div class="alert-panel-content">
    <div class="alert-panel-label">{{ viewModel.alertType }}</div>
    <div class="alert-panel-status">
      <ng-container *ngIf="viewModel.subscribedCount > 0; else setupText">
        <span class="subscribed">{{ viewModel.subscribedCount }}</span> of
        <span class="total">{{ viewModel.totalCount }}</span>
      </ng-container>
      <ng-template #setupText>
        <span>Click to set up</span>
      </ng-template>
    </div>
  </div>
  <div class="alert-panel-chevron">
    <ion-icon name="chevron-forward-outline"></ion-icon>
  </div>
</div>
